const KILO = 1000;
const KILOMETERS_PER_MILE = 1.60934;
const FEET_PER_MILE = 5280;

export const convertMilesToKilometers = (miles: number): number => miles * KILOMETERS_PER_MILE;
export const convertMilesToMeters = (miles: number): number => miles * KILOMETERS_PER_MILE * KILO;
export const convertMilesToFeet = (miles: number): number => miles * FEET_PER_MILE;
